/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PageContainer = ({
  hasExtension,
  className,
  children
}) => {
  const myRef = useRef();
  useEffect(() => {
    const ele = myRef.current.parentNode;
    ele.style.overflowX = 'hidden';
  }, []); // Handle auto scroll effect when user clicks "Have a question"

  useEffect(() => {
    const ele = myRef.current.parentNode;
    const scrollDuration = 1500;
    const scrollStep = 500 / (scrollDuration / 15);
    const scrollInterval = setInterval(() => {
      ele.scrollTop = hasExtension ? ele.scrollTop + scrollStep : ele.scrollTop;
    }, 15);
    setTimeout(() => clearInterval(scrollInterval), scrollDuration - 500);
  }, [hasExtension]);
  return /*#__PURE__*/React.createElement("div", {
    ref: myRef,
    className: className,
    id: "page-container"
  }, children);
};

PageContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  hasExtension: PropTypes.bool
};
export default styled(PageContainer)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;